

/*

The MIT License (MIT)

Copyright (c) Michael L. Davis <michael@swfm.com> (Software Farm, Inc.)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
import ZUtil from './zutil';

/*
 * This is an in-memory data store with listener functionality 
 * that has many idempotence and immutable properties. Data put
 * in here is guaranteed not to change unless explicitly changed 
 * by updating the value using the ZProps.set() function.
 *
 */


const DELIMETER = "Zprops.unused_delimeter"; // ":"
var ZProps = {
	_listeners: {},
	_mutables: {},
	_uniq: 1,
	
	init: function(callback) {
		callback();
	},
	genUniqueURI: function(root) {
		return root + Date.now() + ":" + this._uniq++;
	},
	addListener: function(name, callback, singleton) {
		ZUtil.assert(typeof callback === 'function', "addListener for name '" + name + "' has no callback");
		ZUtil.assert(typeof name === 'string', "addListener for unknown name: " + name);
		this._listeners[name] = singleton ? [] : (this._listeners[name] || []);
		this._listeners[name].push(callback);
		return { name: name, callback: callback };
	},
	removeListener: function(name, callback) {
		if (typeof name !== "string") {
			callback = name.callback;
			name = name.name;
		}
		var subs = this._listeners[name] || [];
		var unsub = 0;
		for (var i = 0, len = subs.length; i < len; ++i) {
			if (subs[i] === callback) {
				subs.splice(i, 1);
				--i;
				--len;
				++unsub;
			}
		}
		if (unsub === 0) {
			console.error("State.removeListener found no listeners", {name: name});
		}
	},
	listeners: function(name) {
		return this._listeners[name] && this._listeners[name].length > 0;
	},
	// transient object, not immutable
	sett: function(name, value, force) {
		var oldvalue = this._mutables[name];
		if (oldvalue !== value || force) {
			this._mutables[name] = value;
			this._notify(name, oldvalue);
		}
	},
	gett: function(name, value) {
		return this._mutables[name];
	},
	set: function(name, value) {
if (value === undefined) {
console.error(`Zglobalstate - warning setting property ${name} to undefined. Use null instead.`);
}

		var oldvalue = __ZProps.peek(name);
		// never equal if objects not strings or numbers
		if (value !== oldvalue) {
			__ZProps.set(name, value);
			this._notify(name, oldvalue);
		}
	},
	get: function(name) {
		return __ZProps.get(name);
	},
	del: function(name) {
		return __ZProps.del(name);
	},
	_notify: function(name, oldvalue) {
		// percolate up notifications (note /user/location !== /person/id i.e. user is this browser's user, person is another user)
		// notify listeners to basic object first perhaps for no other reason than we want ZModel.user to always be updated first as the
		// ultimate holder of the current user state
		var subs = [];
		if (name.indexOf(DELIMETER, 1) !== -1) {
			//this._notify(name.substring(0, name.lastIndexOf(DELIMETER)));
			subs = this._listeners[name.substring(0, name.lastIndexOf(DELIMETER))]
			name = name.substring(name.lastIndexOf(DELIMETER) + 1);
		} else {
			subs = this._listeners[name];
		}
		if (subs) {
			var data = __ZProps.get(name);
			for (var i = 0, len = subs.length; i < len; ++i) {
				if (!subs[i]) {
					throw new Error("bad subscriber: " + subs[i] + ", subs.length=" + subs.length + ",name=" + name);
				} else {
					subs[i](name, data, oldvalue);
				}
			}
		}
	},
};
var __ZProps = {
	_store: {},
	set: function(name, data) {
		var index = name.lastIndexOf(DELIMETER), field;
		if (index !== -1 && index !== 0) { 
			field = name.substring(index + 1);
			name = name.substring(0, index);
			this._store[name][field] = ZUtil.clone(data);
		} else {
			this._store[name] = ZUtil.clone(data);
		}
	},
	get: function(name) {
		var index = name.lastIndexOf(DELIMETER), field;
		// support user/host 
		if (index !== -1 && index !== 0) { 
			field = name.substring(index + 1);
			name = name.substring(0, index);
			if (!this._store[name]) {
				return null;
			}
			return ZUtil.clone(this._store[name][field]);
		}
		return ZUtil.clone(this._store[name]);
	},
	peek: function(name) {
		var index = name.lastIndexOf(DELIMETER), value, field;
		if (index !== -1 && index !== 0) { 
			field = name.substring(index + 1);
			name = name.substring(0, index);
			if (!this._store[name]) {
				this._store[name] = {};
			}
			value = this._store[name][field];
		} else {
			value = this._store[name];
		}
		return (value); 
	},
	del: function(name) {
		delete this._store[name];
	}
}
export default ZProps;





// WEBPACK FOOTER //
// ./src/zprops.js